import React, { useEffect, useState } from 'react';
import { accountsReceivableAPI } from './services/accountsReceivableApi';

/**
 * "Bill as" picker for invoices and quotes: the business itself or one of its
 * DBA / division names. Renders nothing when the business has no DBAs, so it
 * never shows an empty or error slot.
 */
export default function BillAsSelect({ businessId, businessName, value, onChange, label = 'Bill as' }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let active = true;
    setOptions([]);
    if (!businessId) return undefined;
    accountsReceivableAPI.getBillAsOptions({ business_id: businessId })
      .then((res) => { if (active) setOptions(Array.isArray(res.data) ? res.data : []); })
      .catch(() => { if (active) setOptions([]); });
    return () => { active = false; };
  }, [businessId]);

  if (!options.length) return null;

  return (
    <div>
      <label htmlFor="bill-as" className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <select
        id="bill-as"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-gray-300 rounded px-3 py-2"
      >
        <option value="">{businessName || 'This business'}</option>
        {options.map((o) => (
          <option key={o.id} value={String(o.id)}>{o.name}</option>
        ))}
      </select>
    </div>
  );
}
